import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'millisecondsConverter' })
export class MillisecondsConverterPipe implements PipeTransform {
    public transform(value: number, args: string[]): any {
        return this.millisToMinutesAndSeconds(value);
    }

    private millisToMinutesAndSeconds(milliseconds: number): string {
        const minutes = Math.floor(milliseconds / 60000);
        const seconds = ((milliseconds % 60000) / 1000);
        return (seconds === 60 ? (minutes + 1) + ':00' : minutes + ':' + (seconds < 10 ? '0' : '') + seconds.toFixed(0));
    }
}